<script>
	import request from './request.vue';
	import Company from'./company.model.vue';
	import Article from'./article.model.vue';

	import { format } from "date-fns";

	let schema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			notInFilters: true,
		},
		{
			name: "user",
			displayName: "Mátricula",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			formatter: value => `${value.register || "Sem matrícula"}`,
		},
		{
			name: "userId",
			displayName: "Usuário",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
		},
		{
			name: "user",
			displayName: "Usuário",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			formatter: value => `${value.name || "Sem nome"}`,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "user",
			displayName: "Email",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			formatter: value => `${value.email || "Sem email"}`,
			notInFilters: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "resultScore",
			displayName: "Resultado",
			kind: "text",
			validation: "required",
			readOnly: true,
			notInFilters: true,
			search: {
				show: true,
			},
		},
		{
			name: "result",
			displayName: "Mensagem",
			kind: "text",
			validation: "required",
			readOnly: true,
			notInFilters: true,
			formatter: value => `${value ? value.text.slice(0, 100) : ""}...`,
			search: {
				show: true,
			},
		},
		{
			name: "creationDate",
			displayName: "Data",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			formatter: value => format(new Date(value).toLocaleString("en-US", {timeZone: "America/sao_paulo"}), "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			notInFilters: true,
			search: {
				show: true,
			},
		},
		// {
		// 	name: "articleId",
		// 	displayName: "Módulo",
		// 	kind: "text",
		// 	validation: "",
		// 	defaultSort: true,
		// 	readOnly: true,
		// 	notInFilters: true,
		// 	search: {
		// 		show: false,
		// 	},
		// },
		{
			name: "dateStart",
			displayName: "Data inicial",
			kind: "date",
			validation: "required",
			defaultSort: true,
			readOnly: true,
			formatter: value => format(new Date(value).toLocaleString("en-US", {timeZone: "America/sao_paulo"}), "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			notInResults: true,
			mask: "##/##/####",
			search: {
				show: true,
			},
		},
		{
			name: "dateEnd",
			displayName: "Data final",
			kind: "date",
			validation: "required",
			defaultSort: true,
			readOnly: true,
			formatter: value => format(new Date(value).toLocaleString("en-US", {timeZone: "America/sao_paulo"}), "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			notInResults: true,
			mask: "##/##/####",
			search: {
				show: true,
			},
		},
		{
			name: "platform",
			displayName: "Plataforma",
			kind: "select",
			validation: "required",
			placeholder: "",
			readOnly: true,
			formatter: value => value ? value : "WEB",
			options: [
				{
					name: "WEB",
					value: "WEB",
				},
				{
					name: "APP",
					value: "APP",
				}
			],
			search: {
				show: true,
			}
		},
	];

	export default {
		loadingData: false,
		getSchema: function() {
			schema = schema.filter(function( obj ) {
					return obj.displayName !== 'Empresa' && obj.displayName !== 'Módulo';
			});

			Company.getAll()
			.then((companies) => {
				schema.push({
					name: "company",
					displayName: "Empresa",
					kind: "select",
					validation: "required",
					defaultSort: true,
					readOnly: true,
					options: companies.map(company => ({
						name: company.name,
						value: company.id,
					})),
					formatter: value => `${value ? value.name : "Sem companhia"}`,
					search: {
						show: true,
					},
				})
			})
			.catch((err) => console.log(err));
		
			Article.getAll()
				// .then((articles) => {
				// 	const currentArticle = articles.filter(item => item.name === "Avaliação Emocional");
				// 	schema.push({
				// 		name: "article",
				// 		displayName: "Módulo",
				// 		kind: "select",
				// 		currentValue: currentArticle[0].name,
				// 		validation: "",
				// 		defaultSort: true,
				// 		readOnly: true,
				// 		options: articles.map(article => ({
				// 			name: article.name,
				// 			value: article.name,
				// 		})),
				// 		formatter: value => `${value.name}`,
				// 		search: {
				// 			show: true,
				// 			endWildcard: true,
				// 			startWildcard: true,
				// 		},
				// 	})
				// })
				.catch((err) => console.log(err));

			return schema;
		},
		search: async function(parameters) {
			if (parameters.dateStart) parameters.dateStart = parameters.dateStart.split("/").reverse().join("-");
			if (parameters.dateEnd) parameters.dateEnd = parameters.dateEnd.split("/").reverse().join("-");

			parameters.orderBy = "creationDate";
			parameters.orderDirection = "desc";
			//parameters.article = "Avaliação Emocional";
			parameters.articleId = 6080;

			console.log(parameters);
			const response = await request.send("userTestResult", "search", parameters, true);
			console.log(response);
			return response;
		},
		download: async function(parameters) {
			if (parameters.dateStart) parameters.dateStart = parameters.dateStart.split("/").reverse().join("-");
			if (parameters.dateEnd) parameters.dateEnd = parameters.dateEnd.split("/").reverse().join("-");

			const response = await request.send("userTestResult", "searchEmailList", parameters, true);
			return response;
		}
	}
</script>
